// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Managebutton_manageButton__EEyV4 {
  color: white;
  background-color: #ff6500;
  border: 1px solid #ff6500;
  border-radius: 6px;
  margin-right: 6px;
  width: 123px;
  height: 33px;
  line-height: 14px;
  font-family: Roboto;
  font-size: 12px; /* Optional: adjust font size */
  transition: background-color 0.3s, color 0.3s, transform 0.1s;
}

.Managebutton_manageButton__EEyV4:hover {
  background-color: #ff7b33; /* Adjust brightness for hover */
  border-color: #ff7b33; /* Brighten border as well */
}

.Managebutton_manageButton__EEyV4:active {
  background-color: white;
  color: #ff6500;
  border-color: #ff6500;
  transform: scale(0.98); /* Optional: subtle click-in effect */
}

.Managebutton_AddButton__0Szz5 {
  color: white;
  background-color: #ff6500;
  border: 1px solid #ff6500;
  border-radius: 6px;
  margin-top: 6px;
  width: 123px;
  height: 33px;
  line-height: 14px;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  transition: background-color 0.3s, color 0.3s, transform 0.1s;
}

/* Hover effect - make it brighter */
.Managebutton_AddButton__0Szz5:hover {
  background-color: #ff7b33; /* Adjust brightness for hover */
  border-color: #ff7b33; /* Brighten border as well */
}

/* Active (click) effect - swap background and text colors */
/* .AddButton:active {
  background-color: white;
  color: #ff6500;
  border-color: #ff6500;
  transform: scale(0.98); 
} */

.Managebutton_AddButton__0Szz5.Managebutton_clicked__NBIxp {
  background-color: white;
  color: #ff6500;
  border-color: #ff6500;
}

.Managebutton_avatar-circle__2l2uT {
}

.Managebutton_AddFriend__7Cpc- {
  /* width: 300px;
  top: 112px;
  left: 62px; */
  height: 100%;
  gap: 2px;
  opacity: 0px;
}

.Managebutton_SearchList__F6CZf {
  border: 1px solid #dcdcdc;
  background: none;
  border-radius: 10px;
  overflow-y: auto;
  max-height: 10;
  gap: 2;
}

.Managebutton_SearchList__F6CZf::-webkit-scrollbar {
  display: none;
}

.Managebutton_addfriendlistitem__-NTqs {
  border-radius: 8px 0px 0px 0px;
  opacity: 0px;
  background: #eff4f7;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px;
  border: 0.5px solid #dcdcdc;
}

.Managebutton_addContactiteminfo__JwM3k {
  text-align: left;
  margin-left: 10px;
  line-height: 4px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  flex: 1 1;
  padding-top: 12px;
  font-size: 20px;
  color: #6c757d;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/BuzzCom/Style/Managebutton.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe,EAAE,+BAA+B;EAChD,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;EAC3D,qBAAqB,EAAE,4BAA4B;AACrD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,sBAAsB,EAAE,qCAAqC;AAC/D;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,6DAA6D;AAC/D;;AAEA,oCAAoC;AACpC;EACE,yBAAyB,EAAE,gCAAgC;EAC3D,qBAAqB,EAAE,4BAA4B;AACrD;;AAEA,4DAA4D;AAC5D;;;;;GAKG;;AAEH;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;AACA;;AAEA;EACE;;eAEa;EACb,YAAY;EACZ,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,SAAO;EACP,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".manageButton {\n  color: white;\n  background-color: #ff6500;\n  border: 1px solid #ff6500;\n  border-radius: 6px;\n  margin-right: 6px;\n  width: 123px;\n  height: 33px;\n  line-height: 14px;\n  font-family: Roboto;\n  font-size: 12px; /* Optional: adjust font size */\n  transition: background-color 0.3s, color 0.3s, transform 0.1s;\n}\n\n.manageButton:hover {\n  background-color: #ff7b33; /* Adjust brightness for hover */\n  border-color: #ff7b33; /* Brighten border as well */\n}\n\n.manageButton:active {\n  background-color: white;\n  color: #ff6500;\n  border-color: #ff6500;\n  transform: scale(0.98); /* Optional: subtle click-in effect */\n}\n\n.AddButton {\n  color: white;\n  background-color: #ff6500;\n  border: 1px solid #ff6500;\n  border-radius: 6px;\n  margin-top: 6px;\n  width: 123px;\n  height: 33px;\n  line-height: 14px;\n  font-family: Roboto, sans-serif;\n  font-size: 12px;\n  transition: background-color 0.3s, color 0.3s, transform 0.1s;\n}\n\n/* Hover effect - make it brighter */\n.AddButton:hover {\n  background-color: #ff7b33; /* Adjust brightness for hover */\n  border-color: #ff7b33; /* Brighten border as well */\n}\n\n/* Active (click) effect - swap background and text colors */\n/* .AddButton:active {\n  background-color: white;\n  color: #ff6500;\n  border-color: #ff6500;\n  transform: scale(0.98); \n} */\n\n.AddButton.clicked {\n  background-color: white;\n  color: #ff6500;\n  border-color: #ff6500;\n}\n\n.avatar-circle {\n}\n\n.AddFriend {\n  /* width: 300px;\n  top: 112px;\n  left: 62px; */\n  height: 100%;\n  gap: 2px;\n  opacity: 0px;\n}\n\n.SearchList {\n  border: 1px solid #dcdcdc;\n  background: none;\n  border-radius: 10px;\n  overflow-y: auto;\n  max-height: 10;\n  gap: 2;\n}\n\n.SearchList::-webkit-scrollbar {\n  display: none;\n}\n\n.addfriendlistitem {\n  border-radius: 8px 0px 0px 0px;\n  opacity: 0px;\n  background: #eff4f7;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px;\n  border: 0.5px solid #dcdcdc;\n}\n\n.addContactiteminfo {\n  text-align: left;\n  margin-left: 10px;\n  line-height: 4px;\n  font-weight: 500;\n  font-family: \"Roboto\", sans-serif;\n  flex: 1;\n  padding-top: 12px;\n  font-size: 20px;\n  color: #6c757d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageButton": `Managebutton_manageButton__EEyV4`,
	"AddButton": `Managebutton_AddButton__0Szz5`,
	"clicked": `Managebutton_clicked__NBIxp`,
	"avatar-circle": `Managebutton_avatar-circle__2l2uT`,
	"AddFriend": `Managebutton_AddFriend__7Cpc-`,
	"SearchList": `Managebutton_SearchList__F6CZf`,
	"addfriendlistitem": `Managebutton_addfriendlistitem__-NTqs`,
	"addContactiteminfo": `Managebutton_addContactiteminfo__JwM3k`
};
export default ___CSS_LOADER_EXPORT___;
